import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeaturedProductsComponent } from './featured-products/featured-products.component';
import { CustomOrdersComponent } from './custom-orders/custom-orders.component';
import { UnknownErrorComponent } from './unknown-error/unknown-error.component';
import { NotFoundComponent } from './404/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: FeaturedProductsComponent,
    data: {
      breadcrumb: 'Acasă',
      title: 'Calculator tablă acoperiș Bilka & Wetterbest',
      metaDescription:
        'Calculator acoperiș Bilka și  Wetterbest - Utilizați calculatorul nostru pentru a estima rapid prețul acoperișului tău. Transport gratuit oriunde în țară. Ai 30 de ani garanție.',
    },
  },
  {
    path: 'produse',
    loadChildren: () => import('./products/products.module').then((m) => m.ProductsModule),
    data: {
      title: 'Produse',
      breadcrumb: 'Produse',
      metaDescription: '',
    },
  },
  {
    path: 'preturi',
    redirectTo: '/produse',
  },
  {
    path: `calcul-aproximativ`,
    loadChildren: () => import('./approximate/approximate.module').then((m) => m.ApproximateModule),
  },
  {
    path: 'calcul-acoperiș',
    data: {
      // breadcrumb: 'Calculator acoperiș',
      skipBreadcrumb: true,
    },
    loadChildren: () => import('./calculation/calculation.module').then((m) => m.CalculationModule),
  },
  {
    path: 'calcul',
    data: {
      skipBreadcrumb: true,
    },
    loadChildren: () => import('./calculation/calculation.module').then((m) => m.CalculationModule),
  },
  {
    path: 'calculation/:calculationId',
    redirectTo: 'calcul/:calculationId',
  },
  {
    path: 'sistem-pluvial',
    loadChildren: () => import('./rain-system/rain-system.module').then((m) => m.RainSystemModule),
  },
  {
    path: 'custom-orders',
    component: CustomOrdersComponent,
    data: {
      title: 'Comenzi personalizate',
      breadcrumb: 'Comenzi personalizate',
      metaDescription: '',
    },
  },
  {
    path: 'cos',
    loadChildren: () => import('./cart/cart.module').then((m) => m.CartModule),
    data: {
      title: 'Coș de cumpărături',
      breadcrumb: 'Coș de cumpărături',
      metaDescription: '',
    },
  },
  {
    path: 'order',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: 'comanda',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    data: {
      title: 'Login',
      breadcrumb: 'Login',
      metaDescription: '',
    },
  },
  {
    path: 'error',
    component: UnknownErrorComponent,
    data: {
      title: 'S-a produs o eroare',
      metaDescription: '',
    },
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: {
      title: 'Pagina nu a fost găsită',
      metaDescription: '',
      breadcrumb: 'Pagina nu a fost găsită',
    },
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
